//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** The sort property */
export const ConnectionRequestViewModelSortProperty = {
    /** The requestor */
    Requestor: 0,

    /** The requestor desc */
    RequestorDesc: 1,

    /** The connector */
    Connector: 2,

    /** The connector desc */
    ConnectorDesc: 3,

    /** The date added */
    DateAdded: 4,

    /** The date added desc */
    DateAddedDesc: 5,

    /** The last activity */
    LastActivity: 6,

    /** The last activity desc */
    LastActivityDesc: 7,

    /** The order */
    Order: 8,

    /** The campus */
    Campus: 9,

    /** The campus desc */
    CampusDesc: 10,

    /** The group */
    Group: 11,

    /** The group desc */
    GroupDesc: 12,

    /** The status */
    Status: 13,

    /** The status desc */
    StatusDesc: 14,

    /** The state */
    State: 15,

    /** The state desc */
    StateDesc: 16
} as const;

/** The sort property */
export const ConnectionRequestViewModelSortPropertyDescription: Record<number, string> = {
    0: "Requestor",

    1: "Requestor Desc",

    2: "Connector",

    3: "Connector Desc",

    4: "Date Added",

    5: "Date Added Desc",

    6: "Last Activity",

    7: "Last Activity Desc",

    8: "Order",

    9: "Campus",

    10: "Campus Desc",

    11: "Group",

    12: "Group Desc",

    13: "Status",

    14: "Status Desc",

    15: "State",

    16: "State Desc"
};

/** The sort property */
export type ConnectionRequestViewModelSortProperty = typeof ConnectionRequestViewModelSortProperty[keyof typeof ConnectionRequestViewModelSortProperty];
